import './ShortTextCell.css'

function ShortTextCell({text,style}) {
  return (
    <td style={style}>{text}</td>
  )
}

export default ShortTextCell